webpackJsonp([82807954938267],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageGallery = __webpack_require__(41);
	
	var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
	
	var _images = __webpack_require__(24);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imagesModal = _images2.default['urbanSketching'][0];
	var imagesThumb = _images2.default["urbanSketching"][1];
	
	var sketchbook = function sketchbook() {
	    return _react2.default.createElement(_ImageGallery2.default, { imagesModal: imagesModal, imagesThumb: imagesThumb, tabName: 'URBAN SKETCHING' });
	};
	
	exports.default = sketchbook;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-urban-sketching-js-dc73905f5552b9a6e293.js